export const active_plan_success = (data) => ({ type: 'ACTIVE_PLAN_SUCCESS', data });
export const clear_plan_success = (data) => ({ type: 'CLEAR_ACTIVE_PLAN', data });